var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"results-sub-header"},[_c('div',{staticClass:"category-title boxed"},[_c('h5',[_vm._v(_vm._s(_vm.categoryName))])])])}
var staticRenderFns = []

export { render, staticRenderFns }